module.exports = __webpack_public_path__ + "assets/azure.2804952b.svg";